import component from "containers/StaticPages/pages/HomeLight";

export default {
  key: "home-light",
  title: "Home Light",
  path: "/:user?/home-light",
  pageName: "homeLight",
  linkTarget: "/home-light",
  component,
};
